import React from "react";
import { Empty, Button, Tooltip } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import styles from "./HistoryList.module.css";

interface IHistoryListExtensionOfStayProps {
  onAddNew?: () => void;
  onViewItem?: (item: any, orderNumber: number) => void;
  loading?: boolean;
  isLastExtensionOfStayCompleted: boolean;
  getAllExtensionOfStayRequests: any;
}

const HistoryListExtensionOfStay: React.FC<
  IHistoryListExtensionOfStayProps
> = ({
  onAddNew,
  onViewItem,
  loading = false,
  isLastExtensionOfStayCompleted,
  getAllExtensionOfStayRequests,
}) => {
  const orderedUnlistedProcedures = [...(getAllExtensionOfStayRequests || [])]; //.reverse()

  return (
    <div className={styles.historyListContainer}>
      <div className={styles.header}>
        <div>
          <h3 className={styles.title}>EXTENSION OF STAY HISTORY</h3>
        </div>
        {onAddNew && isLastExtensionOfStayCompleted && (
          <Button
            type="primary"
            icon={<PlusCircleOutlined />}
            onClick={onAddNew}
            loading={loading}
            style={{ background: "#00549E", color: "white" }}
          >
            Add New
          </Button>
        )}
      </div>

      {orderedUnlistedProcedures.length > 0 ? (
        <div className={styles.listContainer}>
          {orderedUnlistedProcedures.map((item: any, index: number) => {
            const orderNumber = orderedUnlistedProcedures.length - index;
            return (
              <div
                key={`${item.caseId}-${orderNumber}`}
                className={styles.historyCard}
              >
                <div className={styles.cardHeader}>
                  <div>
                    <h4 className={styles.cardTitle}>
                      Extension of Stay - {orderNumber}
                    </h4>
                  </div>

                  {onViewItem ? (
                    <Button
                      type="primary"
                      onClick={() => onViewItem(item, orderNumber)}
                    >
                      View Details
                    </Button>
                  ) : null}
                </div>

                <div className={styles.cardBody}>
                  <div className={styles.cardRow}>
                    <span className={styles.cardLabel}>Remarks:</span>
                    <span className={styles.cardValue}>
                      {item?.remark || "-"}
                    </span>
                  </div>

                  <div className={styles.cardRow}>
                    <span className={styles.cardLabel}>Diagnosis:</span>
                    <Tooltip title={item?.diagnosis} placement="topLeft">
                      <span className={styles.cardValue}>
                        {item?.diagnosis || "-"}
                      </span>
                    </Tooltip>
                  </div>

                  <div className={styles.cardRow}>
                    <span className={styles.cardMetaBlock}>
                      <strong>Annexure Uploaded:</strong>
                      <span
                        className={
                          item?.annextureUploaded
                            ? styles.statusYes
                            : styles.statusNo
                        }
                      >
                        {item?.annextureUploaded ? "Yes" : "No"}
                      </span>
                    </span>

                    <span className={styles.cardMetaBlock}>
                      <strong>Submitted on Portal:</strong>
                      <span
                        className={
                          item?.annextureSubmittedOnPortal
                            ? styles.statusYes
                            : styles.statusNo
                        }
                      >
                        {item?.annextureSubmittedOnPortal ? "Yes" : "No"}
                      </span>
                    </span>
                  </div>

                  {/* <div className={styles.cardRow}>
                    <span className={styles.cardMetaBlock}>
                      <strong>Annexure Uploaded:</strong>{' '}
                      {item?.annextureUploaded ? 'Yes' : 'No'}
                    </span>
                    <span className={styles.cardMetaBlock}>
                      <strong>Submitted on Portal:</strong>{' '}
                      {item?.annextureSubmittedOnPortal ? 'Yes' : 'No'}
                    </span>
                  </div> */}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <Empty description="No procedures found" />
      )}
    </div>
  );
};

export default HistoryListExtensionOfStay;
